import { storableError } from '../../util/errors';
import { listThreads } from '../../util/api';
import { getTokensFromCookies } from '../../util/cookieUtils';

// ================ Action types ================ //

export const RESET_THREADS_PAGE = 'app/ThreadsPage/RESET_THREADS_PAGE';
export const FETCH_THREADS_REQUEST = 'app/ThreadsPage/FETCH_THREADS_REQUEST';
export const FETCH_THREADS_SUCCESS = 'app/ThreadsPage/FETCH_THREADS_SUCCESS';
export const FETCH_THREADS_ERROR = 'app/ThreadsPage/FETCH_THREADS_ERROR';
export const SET_CURRENT_PAGE = 'app/ThreadsPage/SET_CURRENT_PAGE';

// ================ Reducer ================ //

const initialState = {
  threads: [],
  fetchInProgress: false,
  fetchThreadsError: null,
  pageNumber: 1,
  pageSize: 50,
  totalEntries: 0,
  totalPages: 0,
  currentPage: 1,
};

export default function threadsPageReducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case RESET_THREADS_PAGE:
      return initialState;
    case FETCH_THREADS_REQUEST:
      return { ...state, fetchInProgress: true, fetchThreadsError: null };
    case FETCH_THREADS_SUCCESS:
      return {
        ...state,
        fetchInProgress: false,
        threads: payload.threads,
        pageNumber: payload.pageNumber,
        pageSize: payload.pageSize,
        totalEntries: payload.totalEntries,
        totalPages: payload.totalPages,
      };
    case FETCH_THREADS_ERROR:
      return { ...state, fetchInProgress: false, fetchThreadsError: payload.error };
    case SET_CURRENT_PAGE:
      return { ...state, currentPage: payload.page };
    default:
      return state;
  }
}

// ================ Action creators ================ //

export const resetThreadsPage = () => ({
  type: RESET_THREADS_PAGE,
});

const fetchThreadsSuccess = ({ threads, pageNumber, pageSize, totalEntries, totalPages }) => ({
  type: FETCH_THREADS_SUCCESS,
  payload: { threads, pageNumber, pageSize, totalEntries, totalPages },
});

const fetchThreadsError = error => ({
  type: FETCH_THREADS_ERROR,
  payload: { error },
});

export const setCurrentPage = (page) => ({
  type: SET_CURRENT_PAGE,
  payload: { page },
});

// ================ Thunks ================ //

export const loadData = () => async (dispatch, getState, sdk) => {
  dispatch(resetThreadsPage());
  dispatch(setCurrentPage(1));
  dispatch({ type: FETCH_THREADS_REQUEST });

  try {
    const { accessToken, refreshToken } = getTokensFromCookies();

    const response = await listThreads({ page: 1 }, { 
      'legacy-auth-token': accessToken,
      'refresh-token': refreshToken
    });

    const { entries, page_number, page_size, total_entries, total_pages } = response;

    dispatch(fetchThreadsSuccess({
      threads: entries,
      pageNumber: page_number,
      pageSize: page_size,
      totalEntries: total_entries,
      totalPages: total_pages,
    }));
  } catch (error) {
    console.error('Error loading threads:', error);
    dispatch(fetchThreadsError(storableError(error)));
  }
};

export const loadThreadPage = (page) => async (dispatch, getState, sdk) => {
  dispatch(setCurrentPage(page));
  dispatch({ type: FETCH_THREADS_REQUEST });

  try {
    const { accessToken, refreshToken } = getTokensFromCookies();

    const response = await listThreads({ page }, { 
      'legacy-auth-token': accessToken,
      'refresh-token': refreshToken
    });

    const { entries, page_number, page_size, total_entries, total_pages } = response;

    dispatch(fetchThreadsSuccess({
      threads: entries,
      pageNumber: page_number,
      pageSize: page_size,
      totalEntries: total_entries,
      totalPages: total_pages,
    }));
  } catch (error) {
    console.error('Error loading more threads:', error);
    dispatch(fetchThreadsError(storableError(error)));
  }
};
